import React, { useState, useEffect } from 'react';
import { Field } from 'react-final-form';
import css from './IntegerRangeFilter.module.css';

// const PRICE_OPTIONS = [
//     { value: 0, label: 'No min' },
//     { value: 100000, label: '£100,000' },
//     { value: 200000, label: '£200,000' },
//     { value: 300000, label: '£300,000' },
//     { value: 400000, label: '£400,000' },
//     { value: 500000, label: '£500,000' },
//     { value: 750000, label: '£750,000' },
//     { value: 1000000, label: '£1,000,000' },
//     { value: 1500000, label: '£1,500,000' },
//     { value: 2000000, label: '£2,000,000' },
//     { value: 3000000, label: '£3,000,000' },
//     { value: 5000000, label: '£5,000,000' },
//     { value: 7500000, label: '£7,500,000' },
//     { value: 10000000, label: '£10,000,000' },
//     { value: 15000000, label: '£15,000,000' },
//     { value: 20000000, label: '£20,000,000+' },
// ];

const PRICE_OPTIONS = [
    { value: '', label: 'Min Price' },
    { value: '50000', label: '£50,000' },
    { value: '60000', label: '£60,000' },
    { value: '70000', label: '£70,000' },
    { value: '80000', label: '£80,000' },
    { value: '90000', label: '£90,000' },
    { value: '100000', label: '£100,000' },
    { value: '110000', label: '£110,000' },
    { value: '120000', label: '£120,000' },
    { value: '125000', label: '£125,000' },
    { value: '130000', label: '£130,000' },
    { value: '140000', label: '£140,000' },
    { value: '150000', label: '£150,000' },
    { value: '160000', label: '£160,000' },
    { value: '170000', label: '£170,000' },
    { value: '175000', label: '£175,000' },
    { value: '180000', label: '£180,000' },
    { value: '190000', label: '£190,000' },
    { value: '200000', label: '£200,000' },
    { value: '210000', label: '£210,000' },
    { value: '220000', label: '£220,000' },
    { value: '230000', label: '£230,000' },
    { value: '240000', label: '£240,000' },
    { value: '250000', label: '£250,000' },
    { value: '260000', label: '£260,000' },
    { value: '270000', label: '£270,000' },
    { value: '280000', label: '£280,000' },
    { value: '290000', label: '£290,000' },
    { value: '300000', label: '£300,000' },
    { value: '325000', label: '£325,000' },
    { value: '350000', label: '£350,000' },
    { value: '375000', label: '£375,000' },
    { value: '400000', label: '£400,000' },
    { value: '425000', label: '£425,000' },
    { value: '450000', label: '£450,000' },
    { value: '475000', label: '£475,000' },
    { value: '500000', label: '£500,000' },
    { value: '550000', label: '£550,000' },
    { value: '600000', label: '£600,000' },
    { value: '650000', label: '£650,000' },
    { value: '700000', label: '£700,000' },
    { value: '800000', label: '£800,000' },
    { value: '900000', label: '£900,000' },
    { value: '1000000', label: '£1,000,000' },
    { value: '1250000', label: '£1,250,000' },
    { value: '1500000', label: '£1,500,000' },
    { value: '1750000', label: '£1,750,000' },
    { value: '2000000', label: '£2,000,000' },
    { value: '2500000', label: '£2,500,000' },
    { value: '3000000', label: '£3,000,000' },
    { value: '4000000', label: '£4,000,000' },
    { value: '5000000', label: '£5,000,000' },
    { value: '7500000', label: '£7,500,000' },
    { value: '10000000', label: '£10,000,000' },
    { value: '15000000', label: '£15,000,000' },
    { value: '20000000', label: '£20,000,000' },
];

const resolveMinMaxValues = (values, defaultMax, defaultMin) => {
    const { maxValue, minValue } = values || {};
    return {
        maxValue: maxValue != null ? maxValue : defaultMax,
        minValue: minValue != null ? minValue : defaultMin,
    };
};

const RangeInput = props => {
    const {
        input,
        min: defaultMinValue,
        max: defaultMaxValue,
        initialValues,
    } = props;
    const { value: values = {}, onChange, name } = input;

    const currentValues = resolveMinMaxValues(initialValues[name], defaultMaxValue, defaultMinValue);
    const [fieldValues, setFieldValues] = useState(currentValues);

    useEffect(() => {
        setFieldValues(currentValues);
    }, [initialValues]);

    const handleMinChange = e => {
        const newMin = Number(e.target.value);
        const newValues = { ...fieldValues, minValue: newMin };
        setFieldValues(newValues);
        onChange(newValues);
    };

    const handleMaxChange = e => {
        const newMax = Number(e.target.value);
        const newValues = { ...fieldValues, maxValue: newMax };
        setFieldValues(newValues);
        onChange(newValues);
    };

    const minOptions = PRICE_OPTIONS;
    const maxOptions = [
        ...PRICE_OPTIONS.slice(1),
        { value: 20000000, label: 'No max' },
    ];

    return (
        <div style={{ padding: '12px 0' }}>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', color: '#666' }}>
                        Min Price
                    </label>
                    <select
                        value={fieldValues.minValue}
                        onChange={handleMinChange}
                        style={{
                            width: '100%',
                            padding: '8px 12px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            fontSize: '14px',
                            cursor: 'pointer',
                        }}
                    >
                        {minOptions.map(opt => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </div>
                <span style={{ marginTop: '16px', color: '#666' }}>to</span>
                <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', color: '#666' }}>
                        Max Price
                    </label>
                    <select
                        value={fieldValues.maxValue}
                        onChange={handleMaxChange}
                        style={{
                            width: '100%',
                            padding: '8px 12px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            fontSize: '14px',
                            cursor: 'pointer',
                        }}
                    >
                        {maxOptions.map(opt => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};

const FieldSelectPriceRange = props => {
    const { max, min, name, step = 5, isInSideBar = false, ...rest } = props;
    return (
        <Field
            max={max}
            min={min}
            name={name}
            step={step}
            isInSideBar={isInSideBar}
            component={RangeInput}
            {...rest}
        />
    );
};

export default FieldSelectPriceRange;
